import React from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
const IconOffline = (props) => {
    const defaultSize = 14;
    const { size, color, bgColor, sx, className, ...restProps } = props;
    return (React.createElement(Box, { component: "span", className: clsx('ui-internal-icon', className), display: "inline-flex", sx: { color, fontSize: size ?? defaultSize, background: bgColor, ...sx }, "aria-hidden": true, ...restProps },
        React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6.75C5.51878 6.75 6.75 5.51878 6.75 4C6.75 2.48122 5.51878 1.25 4 1.25C2.48122 1.25 1.25 2.48122 1.25 4C1.25 5.51878 2.48122 6.75 4 6.75ZM4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z", fill: "#8E9194" }))));
};
export default IconOffline;
